(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("jQuery"), require("debug"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "jQuery", "debug", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["mobile"] = factory(require("React"), require("jQuery"), require("debug"), require("ReactDOM"));
	else
		root["mobile"] = factory(root["React"], root["jQuery"], root["debug"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__11__, __WEBPACK_EXTERNAL_MODULE__15__) {
return 